var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { InternalTagType, TagType, } from '@common/api';
export var TagQueryKeys = {
    Tags: ['tags'],
    Actions: ['list_actions'],
    Relations: ['tag_relations'],
};
// type checks
export function isTableTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.type) === TagType.Table;
}
export function isInternalTag(tag) {
    return !!(tag === null || tag === void 0 ? void 0 : tag.internalType);
}
export function isGroupTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.type) === TagType.Group;
}
export function isDimensionTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.type) === TagType.Dimension;
}
export function isAccountTag(tag) {
    return !(tag === null || tag === void 0 ? void 0 : tag.internalType) && (tag === null || tag === void 0 ? void 0 : tag.type) === TagType.Account;
}
export function isMonthTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.Month && tag.type === TagType.Dimension;
}
export function isQuarterTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.Quarter && tag.type === TagType.Dimension;
}
export function isHalfYearTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.HalfYear && tag.type === TagType.Dimension;
}
export function isYearTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.Year && tag.type === TagType.Dimension;
}
export function isYearToDateTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.YearToDate && tag.type === TagType.Dimension;
}
export function isVersionTag(tag) {
    return (tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.Version && tag.type === TagType.Dimension;
}
// =======================
// ==   TAG JSON DATA   ==
// =======================
export var CustomColumnType;
(function (CustomColumnType) {
    CustomColumnType["TEXT"] = "TEXT";
    CustomColumnType["NUMBER"] = "NUMBER";
    CustomColumnType["DATE"] = "DATE";
    CustomColumnType["FILE"] = "FILE";
})(CustomColumnType || (CustomColumnType = {}));
function isCustomColumnType(a) {
    return a === 'NUMBER' || a === 'TEXT' || a === 'FILE' || a === 'DATE';
}
function isCustomColumnFileReference(a) {
    // check object type
    if (typeof a !== 'object' || a === null) {
        return false;
    }
    var aCast = a;
    // check required properties
    if (!('farseerFileId' in aCast) ||
        typeof aCast.farseerFileId !== 'string' ||
        !('filename' in aCast) ||
        typeof aCast.filename !== 'string') {
        return false;
    }
    // check if additional keys exist
    var keys = Object.keys(aCast);
    var allowedKeys = ['farseerFileId', 'filename'];
    if (keys.some(function (k) { return !allowedKeys.includes(k); })) {
        return false;
    }
    // all checks passed
    return true;
}
function isCustomColumnValue(a) {
    // allow strings and numbers
    if (a === null || typeof a === 'string' || typeof a === 'number') {
        return true;
    }
    // check objects
    return isCustomColumnFileReference(a);
}
function isCustomColumnHeader(a) {
    // check object type
    if (typeof a !== 'object' || a === null) {
        return false;
    }
    var aCast = a;
    // check required properties
    if (!('uniqueId' in aCast) ||
        typeof aCast.uniqueId !== 'string' ||
        !('name' in aCast) ||
        typeof aCast.name !== 'string' ||
        !('type' in aCast) ||
        !isCustomColumnType(aCast.type)) {
        return false;
    }
    // check if additional keys exist
    var keys = Object.keys(aCast);
    var allowedKeys = ['uniqueId', 'name', 'type'];
    if (keys.some(function (k) { return !allowedKeys.includes(k); })) {
        return false;
    }
    // all checks passed
    return true;
}
export function isDimensionTagJsonData(a) {
    var e_1, _a;
    // check object type
    if (typeof a !== 'object' || a === null) {
        return false;
    }
    // check keys
    var keys = Object.keys(a);
    if (keys.length !== 1 && keys[0] !== 'values') {
        return false;
    }
    // check required properties
    var aCast = a;
    if (aCast.values === undefined || aCast.values === null || typeof aCast.values !== 'object') {
        return false;
    }
    // check all values
    var valueKeys = Object.keys(aCast.values);
    try {
        for (var valueKeys_1 = __values(valueKeys), valueKeys_1_1 = valueKeys_1.next(); !valueKeys_1_1.done; valueKeys_1_1 = valueKeys_1.next()) {
            var valueKey = valueKeys_1_1.value;
            var value = aCast.values[valueKey];
            if (value !== undefined && !isCustomColumnValue(value)) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (valueKeys_1_1 && !valueKeys_1_1.done && (_a = valueKeys_1.return)) _a.call(valueKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // all checks passed
    return true;
}
export function isTableTagJsonData(a) {
    var e_2, _a;
    // check object type
    if (typeof a !== 'object' || a === null) {
        return false;
    }
    // check keys
    var keys = Object.keys(a);
    if (keys.length !== 1 && keys[0] !== 'headers') {
        return false;
    }
    // check required properties
    var aCast = a;
    if (!Array.isArray(aCast.headers)) {
        return false;
    }
    try {
        // check all headers
        for (var _b = __values(aCast.headers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var header = _c.value;
            if (!isCustomColumnHeader(header)) {
                return false;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    // all checks passed
    return true;
}
